import React from "react";
import "./Modal.scss";
import { Button } from "@mui/material";

interface IModalProps {
  visible?: boolean;
  children: any;
  onSubmit(): void;
  onClose(): void;
  title: string;
  confirmText?: string;
  disableSubmit?: boolean;
  closeOnSubmit?: boolean;
  style?: React.CSSProperties;
}

export const Modal: React.FC<IModalProps> = ({
  visible,
  children,
  onSubmit,
  onClose,
  title,
  confirmText,
  disableSubmit,
  closeOnSubmit = true,
  style,
}) => (
  <div className={"modal " + (visible ? "d-block" : "")} style={style}>
    <div className="modal-dialog" role="document" style={{ top: "20%" }}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            {title}
          </h5>
          {onClose && (
            <button onClick={onClose} type="button" className="close">
              <span> &times;</span>
            </button>
          )}
        </div>
        <div className="modal-body">{children}</div>
        <div className="modal-footer">
          <Button
            variant="outlined"
            size="small"
            sx={{ marginLeft: "2rem", display: "flex" }}
            onClick={() => {
              onSubmit();
              closeOnSubmit && onClose();
            }}
            type="button"
            className="btn btn-secondary close"
            disabled={!!disableSubmit}
          >
            {confirmText ? confirmText : "Save"}
          </Button>
        </div>
      </div>
    </div>
  </div>
);
